import { getClientApiUrl, postJson } from '@avensia/excite/client/api';
import { loginEvent, logoutEvent } from '../events';
import { getDynamicData } from '@avensia/excite';
import { authRequired } from '@avensia/excite/client/api';

export async function login(email: string, password: string) {
  const url = getClientApiUrl('ct/authentication/login');

  try {
    const response: Excite.Commercetools.LoginResponse = await postJson(url, {
      email,
      password,
    } as Excite.Commercetools.LoginRequest);
    if (response.success) {
      await loginEvent.emit();
      getDynamicData<Excite.Commercetools.ICustomerApiModel>().brodcastRefreshToOtherTabsAndWindows();
    }
    return response;
  } catch {
    return { success: false } as Excite.Commercetools.LoginResponse;
  }
}

export async function authenticateIfNeeded() {
  const customerObservable = getDynamicData<Excite.Commercetools.ICustomerApiModel>();
  const customer = await customerObservable.current();
  if (!customer.isLoggedIn) {
    await authRequired.emit(undefined);
    customerObservable.brodcastRefreshToOtherTabsAndWindows();
  } else {
    return true;
  }
}

export async function logout() {
  const url = getClientApiUrl('ct/authentication/logout');

  try {
    const response: Excite.Commercetools.LogoutResponse = await postJson(url);
    if (response.success) {
      await logoutEvent.emit();
      getDynamicData<Excite.Commercetools.ICustomerApiModel>().brodcastRefreshToOtherTabsAndWindows();
    }
    return response;
  } catch {
    return { success: false } as Excite.Commercetools.LogoutResponse;
  }
}
